import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";

const DistributorIcon = (props) => {
  return (
    <ShoppingCartIcon
      style={{
        color: props?.active ? "#6fc0ff" : "#A8A8A8",
        width: 22,
        height: 22,
      }}
    />
  );
};

export default DistributorIcon;
